import styled from "styled-components";

const RightSession = styled.div`
  padding-left: 0.5rem !important;

  @media (max-width: 575px) {
    padding: 0 !important;
  }
`;
export default RightSession;
